import { useTranslation } from 'react-i18next';
import { countAttentionItems } from '@/api/attention/attentionApi.types';
import { AttentionSections } from '@/components/practitioner/shared/AttentionSections';
import { Card } from '@/components/ui/card';
import { useWorkspaceAttentionQuery } from '@/hooks/useWorkspaceAttentionQuery';

interface PortalActivityPanelProps {
  clientId: string;
}

export function PortalActivityPanel({ clientId }: PortalActivityPanelProps) {
  const { t } = useTranslation('dashboard');
  const attentionQuery = useWorkspaceAttentionQuery(clientId);
  const attention = attentionQuery.data;

  if (attention === undefined || countAttentionItems(attention) === 0) {
    return null;
  }

  return (
    <Card as="section">
      <h2 className="text-sm font-bold text-zooindigo">{t('attention.clientPanelTitle')}</h2>
      <p className="text-xs text-zoomuted mt-0.5 mb-3">{t('attention.clientPanelSubtitle')}</p>
      <AttentionSections attention={attention} isScopedToClient />
    </Card>
  );
}
